import { App, Role } from '@agilox/common';

export const AppRoles = {
	[App.my]: [],
	[App.analytics]: [],
	[App.academy]: [],
	[App.docs]: [],
	[App.service]: [Role.support, Role.superuser],
	[App.selftest]: [Role.support, Role.superuser, Role.service],
	[App.lifecycle]: [Role.support, Role.superuser, Role.partner, Role.service],
	[App.plan]: [] as Role[],
	[App.manage]: [Role.support, Role.superuser] as Role[],
} as const;
